import type { ReleasePr } from "../api/releases";

export const TASK_PROJECT = "8fe25ce8-aaf4-4ff5-b4c8-ce445eabe398";
export const TASK_ORG = "c3aa7a0d-461a-4ed4-882a-58bd063b1e62";
import {bodyTask,taskLinkIdentity} from '../../supabase/functions/release-ops/taskLinkIdentity.ts'
export const releaseBodyTask=bodyTask

export type TaskLinkRow = {
  repo: string;
  number: number;
  task_id: string | null;
  head_sha: string;
  manual_override?: boolean;
};
export type LinkedTask = {
  id: string;
  title: string;
  description?: string | null;
  status?: string;
};
export function resolveReleaseTasks(
  prs: ReleasePr[],
  links: TaskLinkRow[],
  tasks: LinkedTask[],
): ReleasePr[] {
  const byPr = new Map(
    links.map((link) => [`${link.repo}#${link.number}`, link]),
  );
  const byId = new Map(tasks.map((task) => [task.id, task]));
  return prs.map((pr) => {
    const link = byPr.get(`${pr.repo}#${pr.number}`),
      identity=taskLinkIdentity(pr.pr_body??"",link);
    const task=byId.get(identity.task_id??"");
    return {
      ...pr,
      ...identity,
      task_link_state: task
        ? (link?.task_id === task.id && link.head_sha === pr.head_sha
          ? "verified"
          : "pending")
        : "missing",
      task: task
        ? {
          ...pr.task,
          ...task,
          url: `https://hub.jumpstart.co.il/tasks/table?task=${task.id}`,
        }
        : null,
    };
  });
}
